import { IAppState } from '../../../AppModulesWrapper';

export function selectIsVisibleViolationsExist(state: IAppState): boolean {
  // return !state.visibleViolations.isValid;
  return false;
}
